export default {
  env: "development",
  home: "https://fuvior.com",
  host: "https://admindev.fuvior.com",
  serverHost: "https://iddev.fuvior.com",
  profile: {
    host: "https://iddev.fuvior.com",
    url: "https://iddev.fuvior.com/p/:userId"
  },
  api: {
    host: "https://apidev.fuvior.com",
    imageHost: "//apidev.fuvior.com/user/upload/avatar",
    importEmployee: "//apidev.fuvior.com/organization/upload/employee",
    product: "fuvior-admin",
    token: "df148f1e582a0ad440589013861ef98c32c1dec2877b8b6d71f4792785a94690"
  },
  color: {
    primary: "#47A76D",
    secondary: "#14929F",
    text: "#243A41",
    text2: "#222222",
    border: "#B1B1B1"
  }
};
